import { BaseViewModel } from "@iot-platform/core";
import type { ConnectionAlertUpdate } from "@station/domain/models/connection-alert.model.ts";
import { ConnectionAlerts } from "@station/domain/models/connection-alert.model.ts";
import { ConnectionAlertGetAllUseCase } from "@station/domain/usecases/connection-alert-get-all.usecase.ts";
import { ConnectionAlertUpdateUseCase } from "@station/domain/usecases/connection-alert-update.usecase.ts";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class ConnectionAlertViewmodel extends BaseViewModel {
    @observable
    initialLoading = false;

    @observable
    private stationId?: string;

    @observable
    connectionAlerts: ConnectionAlerts = ConnectionAlerts.empty();

    constructor(
        @inject(ConnectionAlertUpdateUseCase)
        private readonly connectionAlertUpdateUseCase: ConnectionAlertUpdateUseCase,
        @inject(ConnectionAlertGetAllUseCase)
        private readonly connectionAlertGetAllUseCase: ConnectionAlertGetAllUseCase,
    ) {
        super();
        makeObservable(this);
    }

    override async didMount(): Promise<void> {
        await this.initViewData();
    }

    private async initViewData(): Promise<void> {
        await this.getAllConnectionAlerts();

        runInAction(() => {
            this.initialLoading = false;
        });
    }

    @action
    private async getAllConnectionAlerts(): Promise<void> {
        if (this.stationId) {
            const connectionAlertsFetched =
                await this.connectionAlertGetAllUseCase.execute(this.stationId);
            runInAction(() => {
                this.connectionAlerts = connectionAlertsFetched;
            });
        }
    }

    async updateConnectionAlert(
        updateConnectionAlert: ConnectionAlertUpdate,
        alertId: number,
    ): Promise<void> {
        await this.connectionAlertUpdateUseCase.execute(
            alertId.toString(),
            updateConnectionAlert,
        );
        await this.getAllConnectionAlerts();
    }

    setStationId(stationId: string): void {
        runInAction(() => {
            this.stationId = stationId;
        });
    }
}
